import { render, staticRenderFns } from "./FixResult.vue?vue&type=template&id=3537ab74&scoped=true&"
import script from "./FixResult.vue?vue&type=script&lang=js&"
export * from "./FixResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3537ab74",
  null
  
)

export default component.exports